import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MdAnimatedDirective } from '../../../ui/directives/md-animate.directive';
import { TuiButton, TuiIcon, TuiLoader } from '@taiga-ui/core';
import { TuiButtonLoading, TuiLineClamp } from '@taiga-ui/kit';
import { TuiExpand } from '@taiga-ui/experimental';
import { AiQuestionUi } from '../../../core/ai/ai.model';

@Component({
  selector: 'app-ai-questions',
  imports: [
    MdAnimatedDirective,
    TuiButton,
    TuiButtonLoading,
    TuiExpand,
    TuiIcon,
    TuiLineClamp,
    TuiLoader
  ],
  templateUrl: './ai-questions.html',
  styleUrl: './ai-questions.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiQuestions {
  readonly questions = input<AiQuestionUi[] | null>(null);
  readonly selectedQuestion = input.required<string>();
  readonly isAskAiDisabled = input<boolean>();
  readonly isCreatingAiQuestion = input<boolean>(false);

  readonly askAi = output<void>();
  readonly toggleAiQuestion = output<AiQuestionUi>();
  readonly typingCompleted = output<AiQuestionUi>();
}
